/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {FormSetInfoVertical, FormSetAlternativeBefore, FormSetAlternativeAfter, FormSetAlternativeForms} from 'Docs/uilib/layout/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    strong: "strong",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "Depreciation"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["In order to replace FormSet or FormRow you may use the Eufemia ", _jsx(_components.a, {
        href: "/uilib/usage/customisation/provider-info",
        children: "Provider"
      }), " and ", _jsx(_components.a, {
        href: "/uilib/layout/flex",
        children: "Flex"
      }), " as well as the Eufemia ", _jsx(_components.a, {
        href: "/uilib/extensions/forms",
        children: "Forms Extension"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "e.g. before:"
    }), "\n", _jsx(FormSetAlternativeBefore, {}), "\n", _jsx(_components.p, {
      children: "e.g. after (two examples):"
    }), "\n", _jsx(FormSetAlternativeAfter, {}), "\n", _jsx(FormSetAlternativeForms, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
